import { io } from 'socket.io-client';
import { analyticsIngestorEndpoint } from '../../config';

const socket = io(analyticsIngestorEndpoint, {
  transports: ['websocket'],
  upgrade: false
});

export const catalogueOpened = (companyId, catalogueId, visitorId, openId, slug) => {
  socket.emit('catalogue:open', {
    companyId,
    catalogueId,
    visitorId,
    openId,
    slug,
    timestamp: new Date().toISOString()
  });
};

export const catalogueViewed = (companyId, catalogueId, visitorId, openId) => {
  // for the following cases, we don't need to emit the event to the analytics ingestor
  // 1. Custom Front Page
  // 2. Catalogue Search Results
  // Coincidentally, these cases don't have catalogueId present in it
  // For future cases, if we need to send the event without catalogueId, modify this function
  if (!catalogueId) {
    return;
  }
  socket.emit('catalogue:view', {
    companyId,
    catalogueId,
    visitorId,
    openId,
    timestamp: new Date().toISOString()
  });
};

export const productViewed = (
  productId,
  companyId,
  catalogueId,
  visitorId,
  openId,
  viewId,
  pictureUrl
) => {
  // for the following cases, we don't need to emit the event to the analytics ingestor
  // 1. Custom Front Page
  // 2. Catalogue Search Results
  // Coincidentally, these cases don't have catalogueId present in it
  // For future cases, if we need to send the event without catalogueId, modify this function
  if (!catalogueId) {
    return;
  }
  socket.emit('product:view', {
    productId,
    companyId,
    catalogueId,
    visitorId,
    openId,
    timestamp: new Date().toISOString(),
    viewId,
    pictureUrl
  });
};

export const inquiryCreated = (inquiryId, productId, companyId, catalogueId, visitorId, openId) => {
  socket.emit('inquiry:create', {
    inquiryId,
    productId,
    companyId,
    catalogueId,
    visitorId,
    openId,
    timestamp: new Date().toISOString()
  });
};

export const inquiryDeleted = (inquiryId, productId, companyId, catalogueId, visitorId, openId) => {
  socket.emit('inquiry:delete', {
    inquiryId,
    productId,
    companyId,
    catalogueId,
    visitorId,
    openId,
    timestamp: new Date().toISOString()
  });
};

export const accessCheck = (visitorId, companyId, catalogue) => {
  if (catalogue && catalogue.id) {
    socket.emit('access_check:reset', {
      visitorId,
      companyId,
      catalogueId: catalogue.id,
      timestamp: new Date().toISOString()
    });
  }
};

export const expiryCheck = () => {
  socket.on('access_check:expire', data => {
    window.location.reload();
  });
};
